import React, { useState } from 'react';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoSubject = encodeURIComponent(form.subject || 'Contato via RifaMaker');
    const mailtoBody = encodeURIComponent(
      `Nome: ${form.name}\nE-mail: ${form.email}\n\n${form.message}`
    );
    window.location.href = `mailto:contato@rifamaker.com.br?subject=${mailtoSubject}&body=${mailtoBody}`;
    setSent(true);
  };

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto', padding: '3rem 1.5rem' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Fale Conosco</h1>
      <p style={{ color: 'var(--dark-light)', marginBottom: '2rem', fontSize: '0.95rem', lineHeight: 1.6 }}>
        Tem alguma dúvida, sugestão ou precisa de ajuda? Preencha o formulário abaixo ou envie um e-mail
        diretamente para <a href="mailto:contato@rifamaker.com.br" style={{ color: 'var(--primary)', fontWeight: 600 }}>contato@rifamaker.com.br</a>.
        Responderemos o mais breve possível.
      </p>

      {sent ? (
        <div style={{
          background: 'rgba(0, 206, 158, 0.08)',
          border: '1px solid rgba(0, 206, 158, 0.3)',
          borderRadius: 'var(--radius-md)',
          padding: '2rem',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✉️</div>
          <h3 style={{ margin: '0 0 0.5rem', color: 'var(--dark)' }}>Mensagem preparada!</h3>
          <p style={{ color: 'var(--dark-light)', margin: 0, lineHeight: 1.6 }}>
            Seu aplicativo de e-mail foi aberto com a mensagem. Caso não tenha aberto automaticamente,
            envie diretamente para{' '}
            <a href="mailto:contato@rifamaker.com.br" style={{ color: 'var(--primary)', fontWeight: 600 }}>
              contato@rifamaker.com.br
            </a>.
          </p>
          <button
            onClick={() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }}
            style={{
              marginTop: '1.25rem',
              padding: '0.6rem 1.5rem',
              background: 'var(--primary)',
              color: '#fff',
              border: 'none',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '0.9rem',
            }}
          >
            Enviar outra mensagem
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <label style={labelStyle}>Nome *</label>
              <input
                name="name"
                type="text"
                required
                value={form.name}
                onChange={handleChange}
                placeholder="Seu nome"
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>E-mail *</label>
              <input
                name="email"
                type="email"
                required
                value={form.email}
                onChange={handleChange}
                placeholder="voce@exemplo.com"
                style={inputStyle}
              />
            </div>
          </div>

          <div>
            <label style={labelStyle}>Assunto</label>
            <input
              name="subject"
              type="text"
              value={form.subject}
              onChange={handleChange}
              placeholder="Sobre o que deseja falar?"
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Mensagem *</label>
            <textarea
              name="message"
              required
              value={form.message}
              onChange={handleChange}
              placeholder="Descreva sua dúvida, sugestão ou problema..."
              rows={6}
              style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>

          <button
            type="submit"
            style={{
              padding: '0.85rem',
              background: 'var(--primary)',
              color: '#fff',
              border: 'none',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer',
              fontWeight: 700,
              fontSize: '1rem',
              transition: 'opacity 0.2s',
            }}
          >
            Enviar Mensagem
          </button>
        </form>
      )}

      <div style={{
        marginTop: '3rem',
        padding: '1.5rem',
        background: 'var(--light)',
        borderRadius: 'var(--radius-md)',
        lineHeight: 1.7,
        fontSize: '0.9rem',
        color: 'var(--dark-light)',
      }}>
        <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem', color: 'var(--dark)' }}>Outras formas de contato</h3>
        <p style={{ margin: '0 0 0.5rem' }}>
          📧 <strong>E-mail:</strong>{' '}
          <a href="mailto:contato@rifamaker.com.br" style={{ color: 'var(--primary)' }}>contato@rifamaker.com.br</a>
        </p>
        <p style={{ margin: '0 0 0.5rem' }}>
          ⏰ <strong>Horário de atendimento:</strong> Segunda a Sexta, das 9h às 18h (horário de Brasília)
        </p>
        <p style={{ margin: 0 }}>
          📍 <strong>Tempo de resposta:</strong> Até 2 dias úteis
        </p>
      </div>
    </div>
  );
}

const labelStyle = {
  display: 'block',
  marginBottom: '0.35rem',
  fontWeight: 600,
  fontSize: '0.9rem',
  color: 'var(--dark)',
};

const inputStyle = {
  width: '100%',
  padding: '0.7rem 0.85rem',
  border: '1.5px solid var(--border)',
  borderRadius: 'var(--radius-sm)',
  fontSize: '0.95rem',
  outline: 'none',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box',
};
